export class TrainingItemConstants {
  public static readonly Training_Item_Topbar_Title: string = 'Training Item Group';
  public static readonly Training_Item_Slider_Title: string = 'Create Training Item Group';
  public static readonly Training_Item_Slider_Title_For_Edit: string = 'Edit Training Item Group';
  public static readonly Training_Item_Delete_Message: string = 'You are about to delete a training item. Do you wish to confirm?';
  public static readonly Training_Item_Group_Search_Placeholder = "Search by Code or Name";

  public static readonly Training_Item_Type_Document: number = 1;
  public static readonly Training_Item_Type_Course: number = 2;

  //Spinner Messages
  public static readonly Training_item_Save_InProgress: string =
    'Training Item Group Save is in progress';
  public static readonly Training_item_Update_InProgress: string =
    'Training Item Group Update is in progress';

  public static readonly Training_Item__Created_Success: string =
    'Training Item Group Number Created Successfully';
  public static readonly Training_Item__Creation_Failed: string =
    'Due to some technical issue, the training item group was not created. Please try again.';
  public static readonly Training_Item__Updated_Success: string =
    'Training Item Group Number Updated Successfully';

  public static readonly Training_Item__Group_Details_Loading: string =
    'Fetching Training Item Group Details';

  // Error messages
  public static readonly Training_Item_Scope_Required: string = 'Scope is required.';
  public static readonly Training_Item_Name_Required: string = 'Name is required.';
  public static readonly Training_Item_Creation_Error_Message_Header_Text: string =
    'Please correct the following errors to create the Training Item Group.';
  public static readonly Course_Already_Exists_Error_Message: string =
    'The following Courses are already in the group, it is not possible to add them again. CourseNumbers';
  public static readonly Document_Already_Exists_Error_Message: string =
    'The following Documents are already in the group, it is not possible to add them again. DocumentNumbers';
  public static readonly Atleast_One_Training_Item_Must_Be_Selected_Error_Message: string =
    'A Training Item Group must contain at least one Training Item (Course or Document)'
  public static readonly Selected_Documents_Not_Matching_Error_Message: string =
    'The following Documents cannot be linked to this group as they are associated with a different eQMS Scope. DocumentNumbers'
  public static readonly Selected_Courses_Not_Matching_Error_Message: string =
    'The following Courses cannot be linked to this group as they are associated with a different eQMS Scope. CourseNumbers'
    public static readonly TIGs_UnableToFetchAuth_ErrorMessage: string = 'Unable to get the Curriclum Roles';

  //const values
  public static readonly Training_Item_group_Default_Requiredfields = {
    name: false,
    eqmsScopes: false,
    trainingItems: false
  };

  // Toaster Messages and Severity
  public static readonly Severity_Success: string = 'success';
  public static readonly Severity_Info: string = 'info';
  public static readonly Severity_Err: string = 'error';

  public static readonly TrainingItemGroupDetails : string = 'Training Item Group Details';

  public static readonly Training_Item_Scheduled_True_Value: string = 'True';
  public static readonly Training_Item_Scheduled_False_Value: string = 'False';
}
